import { takeLatest, put } from 'redux-saga/effects';
import {
  CANCEL_BUNDLE_FAILED,
  CANCEL_BUNDLE_SUCCESS,
  CANCEL_BUNDLE,
  GET_BUNDLE_WITH_ID_FAILED,
  GET_BUNDLE_WITH_ID_SUCCESS,
  GET_BUNDLE_WITH_ID,
  GET_BUNDLES_FAILED,
  GET_BUNDLES_SUCCESS,
  GET_BUNDLES,
  UPDATE_BUNDLE_STATUS_FAILED,
  UPDATE_BUNDLE_STATUS_SUCCESS,
  UPDATE_BUNDLE_STATUS,
  GET_LOGS,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_ALL_BUNDLES,
  GET_ALL_BUNDLES_SUCCESS,
  GET_ALL_BUNDLES_FAILED,
} from './constants';

import {
  GetAllBundlesRequestBuilder,
  GetBundlesCountRequestBuilder,
  UpdateBundleStatusRequestBuilder,
  CancelBundleRequestBuilder,
  GetBundleLogsBuilder,
} from 'client-sdk/src/bundles/bundle';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import { flattenObject } from '../../utils/helpers';
import handleNotfication from '../../utils/handleNotification';

const token = localStorage.getItem('token') || '';
export function* getBundles(actions: any) {
  try {
    const makebundlesRequest = new GetAllBundlesRequestBuilder()
      .params(flattenObject({ ...actions.payload, sort: 'created,desc' }))
      .build();
    const makeCountRequest = new GetBundlesCountRequestBuilder()
      .params(flattenObject({ ...actions.payload, sort: 'created,desc' }))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makebundlesRequest);
    const count = yield client.execute(makeCountRequest);
    yield put({
      type: GET_BUNDLES_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_BUNDLES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getAllBundles(actions: any) {
  try {
    const makebundlesRequest = new GetAllBundlesRequestBuilder()
      .params(flattenObject({ ...actions.payload, sort: 'created,desc' }))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makebundlesRequest);
    yield put({
      type: GET_ALL_BUNDLES_SUCCESS,
      data: response.data,

    });
  } catch (error) {
    yield put({
      type: GET_ALL_BUNDLES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getBundleWithId(actions: any) {
  try {
    const makeOrdersRequest = new GetAllBundlesRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeOrdersRequest);
    yield put({
      type: GET_BUNDLE_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_BUNDLE_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateBundleStatus(actions: any) {
  const { id, body, pagination, callback } = actions.payload;
  try {
    const makeUpdateBundleStatusRequest = new UpdateBundleStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateBundleStatusRequest);
    yield put({
      type: UPDATE_BUNDLE_STATUS_SUCCESS,
    });
    yield put({
      type: GET_BUNDLES,
      payload: { ...pagination },
    });

    if(callback) {
      callback();
    }
  } catch (error) {
    yield put({
      type: UPDATE_BUNDLE_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* cancelBundle(actions: any) {
  const { id, body } = actions.payload;
  try {
    const makeCancelBundleRequest = new CancelBundleRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeCancelBundleRequest);
    yield put({
      type: CANCEL_BUNDLE_SUCCESS,
    });
    handleNotfication('مرسوله مورد نظر شمابا موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: CANCEL_BUNDLE_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getLogs(actions: any) {
  try {
    const makeRequest = new GetBundleLogsBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_LOGS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_LOGS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* bundleSaga() {
  yield takeLatest(GET_BUNDLES, getBundles);
  yield takeLatest(GET_BUNDLE_WITH_ID, getBundleWithId);
  yield takeLatest(UPDATE_BUNDLE_STATUS, updateBundleStatus);
  yield takeLatest(CANCEL_BUNDLE, cancelBundle);
  yield takeLatest(GET_LOGS, getLogs);
  yield takeLatest(GET_ALL_BUNDLES, getAllBundles);
}
